import React from 'react'
import { Box, Stack, Typography, useTheme } from '@mui/material'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import DescriptionIcon from '@mui/icons-material/Description'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects'
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight'

const getThumbnail = attachment => {
  const url = attachment.thumbnailLink || attachment.url
  const mime = typeof attachment.mimeType === 'string' ? attachment.mimeType : ''
  const name = attachment.name?.toLowerCase() || ''

  if (mime?.startsWith('image/') || /\.(svg|png|jpe?g|gif)$/i.test(name)) {
    return (
      <Box
        component='img'
        src={url}
        alt={attachment.name}
        sx={{
          width: 30,
          height: 30,
          borderRadius: 1,
          objectFit: 'cover',
        }}
      />
    )
  }

  const FallbackIcon = mime.includes('pdf') || name.endsWith('.pdf') ? PictureAsPdfIcon : DescriptionIcon

  return <FallbackIcon sx={{ fontSize: 30, color: 'text.secondary' }} />
}

const RenderDeleteItems = ({
  task,
  isSubtask,
  context,
  taskComments,
  counts = {},
}: {
  task: any
  isSubtask?: boolean
  context?: string
  taskComments?: any[]
  counts?: { commentCount?: number; attachmentCount?: number }
}) => {
  const theme = useTheme()

  return (
    <Stack display='flex' flexDirection='column' textAlign={'left'} mb={1} width={'100%'}>
      <Box display='flex' alignItems='center' justifyContent={'flex-start'} gap={1}>
        {task?.SK?.startsWith('SUBTASK_') ? (
          <SubdirectoryArrowRightIcon sx={{ color: theme.palette.text.secondary, fontSize: 30 }} />
        ) : context === 'teamTasks' ? (
          <TaskAltIcon sx={{ color: 'rgb(52, 211, 145)', fontSize: 35 }} />
        ) : (
          <EmojiObjectsIcon sx={{ color: 'rgb(111, 31, 223)', fontSize: 35 }} />
        )}
        <Typography sx={{ color: theme.palette.text.secondary, fontWeight: 'bold', textAlign: 'left' }}>
          {task?.name}
        </Typography>
      </Box>

      {/* Comments */}
      {taskComments?.length > 0 && (
        <>
          {counts?.commentCount && counts?.commentCount !== 0 && (
            <Typography sx={{ color: theme.palette.text.secondary, textAlign: 'left', pl: 5 }}>
              {/* {taskComments.length} comment{taskComments.length > 1 ? 's' : ''} linked */}
              {counts?.commentCount || null} comment linked
            </Typography>
          )}

          {counts?.attachmentCount != 0 && (
            <Typography sx={{ color: theme.palette.text.secondary, textAlign: 'left', pl: 5 }}>
              {counts?.attachmentCount || null} attachment(s) linked
            </Typography>
          )}
        </>
      )}

      {/* Attachments */}
      {task.attachments?.length > 0 && (
        <Box pl={5} display='flex' gap={1} alignItems='center' mt={0.5}>
          {task.attachments.slice(0, 3).map((att, idx) => (
            <Box key={idx}>{getThumbnail(att)}</Box>
          ))}
          {task.attachments.length > 3 && (
            <Typography variant='caption' sx={{ color: theme.palette.text.secondary, textAlign: 'left' }}>
              +{task.attachments.length - 3} more
            </Typography>
          )}
        </Box>
      )}
    </Stack>
  )
}

export default RenderDeleteItems
